"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { AddToCartButton, EcommerceProductsProvider, useEcommerceProducts } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
const wp_query_params = {
  per_page: 1,
  product_cat: [18]
};
const wp_query = new WP_Query(wp_query_params);
const specs = [{
  label: "CORE",
  value: "High-Density Mineral Wool"
}, {
  label: "FIRE RATING",
  value: "Class A1 Non-Combustible"
}, {
  label: "APPLICATION",
  value: "Industrial Thermal Insulation"
}];
function CinemaConsumer() {
  const {
    products,
    loading
  } = useEcommerceProducts();
  const product = products && products.length > 0 ? products[0] : null;
  return <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-0 items-stretch">
      {}
      <div className="relative lg:col-span-7 lg:col-start-6 order-1 lg:order-2">
        <div className="relative w-full aspect-video lg:aspect-auto lg:h-full overflow-hidden">
          <img src={product?.featured_image_url || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699139/img/rock_wool_panel_industrial.png"} data-wvc-srcset={product?.featured_image_url ? undefined : "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699139/img/rock_wool_panel_industrial.png-wvc-srcset"} data-wvc-sizes={product?.featured_image_url ? undefined : "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699139/img/rock_wool_panel_industrial.png-wvc-sizes"} alt="High-performance rock wool sandwich panel" loading="lazy" decoding="async" className="h-full w-full object-cover" />
          <div className="absolute inset-0 pointer-events-none" style={{
          background: "linear-gradient(90deg, var(--background) 0%, hsl(210 80% 30% / 0.2) 35%, hsl(210 80% 30% / 0) 70%)"
        }} />

          {}
          <div className="absolute top-6 right-6 md:top-10 md:right-10 z-10">
            <span className="font-default text-[10px] md:text-[11px] uppercase text-primary" style={{
            letterSpacing: "0.25em"
          }}>
              Technical Spec / Series 2025
            </span>
          </div>
        </div>
      </div>

      {}
      <div className="relative lg:col-span-6 lg:col-start-1 lg:row-start-1 order-2 lg:order-1 z-10 bg-card lg:-mr-20 shadow-lg">
        <div className="px-6 py-12 md:px-12 md:py-16 lg:py-24 lg:pl-16 lg:pr-28 h-full flex flex-col justify-center">
          {}
          <p className="font-default text-xs uppercase text-primary mb-6" style={{
          letterSpacing: "0.3em"
        }}>
            Premium Insulation
          </p>

          {}
          <div className="w-px h-12 bg-primary mb-8" aria-hidden="true" />

          {}
          <h2 className="font-default font-bold text-foreground leading-[1.05] mb-8 text-4xl md:text-5xl lg:text-6xl xl:text-[72px]" style={{
          letterSpacing: "-0.01em"
        }}>
            Rock Wool Panels.
          </h2>

          {}
          <p className="text-foreground text-base md:text-lg leading-relaxed mb-12 max-w-md font-default">
            Engineered for maximum thermal efficiency and superior fire resistance. 
            Our rock wool sandwich panels provide the structural integrity and 
            insulation performance required for modern industrial facilities.
          </p>

          {}
          <div className="mb-10 border-t border-border">
            {specs.map((spec, i) => <div key={spec.label} data-index={i} className="flex items-baseline justify-between gap-4 py-4 border-b border-border">
                <span className="font-default text-[11px] uppercase text-foreground shrink-0" style={{
              letterSpacing: "0.25em"
            }}>
                  {spec.label}
                </span>
                <span className="font-default text-sm md:text-base text-foreground text-right">
                  {spec.value}
                </span>
              </div>)}
          </div>

          {}
          <div className="flex flex-col sm:flex-row gap-4 items-start">
            {loading ? <Button disabled className="bg-primary text-primary-foreground hover:bg-primary/90 h-12 px-8 font-default text-xs uppercase tracking-[0.2em] rounded-md">
                Loading...
              </Button> : product ? <AddToCartButton productId={product.id} variant="default" size="lg" text="Request Quote" showQuantity={false} className="w-full sm:w-auto" buttonClassName="bg-primary text-primary-foreground hover:bg-primary/90 h-12 px-8 font-default text-xs uppercase tracking-[0.2em] rounded-md" /> : <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 h-12 px-8 font-default text-xs uppercase tracking-[0.2em] rounded-md" style={{
            letterSpacing: "0.2em"
          }}>
                <Link to="/ContactPage">Request Quote</Link>
              </Button>}

            {product && <Link to={product.link} className="font-default text-xs uppercase text-foreground hover:text-primary transition-colors py-4 border-b border-primary" style={{
            letterSpacing: "0.2em"
          }}>
                View Specs
              </Link>}
          </div>
        </div>
      </div>
    </div>;
}
export default function ProductDetails() {
  return <section data-section-id="5211" id="product-details" className="bg-background text-foreground py-24 md:py-32 lg:py-40 overflow-hidden">
      <EcommerceProductsProvider wp_query={{
      per_page: 1,
      product_cat: [18]
    }}>
        <CinemaConsumer />
      </EcommerceProductsProvider>
    </section>;
}